import WaitlistFormModal from "./WaitlistFormModal";

export default WaitlistFormModal;
